export default __webpack_public_path__ + "static/media/unselected11.fe0e9ffe.png";